import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { noop } from 'ui-components/default-props/noop';

import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import { downloadDocument, printDocument } from '../../../../store/documents/documents.actions';
import { printCustomsForms } from '../../../../store/printing/print.actions';
import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';
import { useCanUserPrintCustomsForms } from '../hooks/use-can-user-print-forms';
import { usePrintSettings } from '../../core/hooks';

export const CustomsForm = ({ fulfillmentIds, fulfillmentPlanIds, onClick: onClickProp = noop }) => {
  const dispatch = useDispatch();
  const canPrintCustoms = useCanUserPrintCustomsForms(fulfillmentPlanIds);
  const printSettings = usePrintSettings(DocumentType.CustomsForm.printSettingKey);

  const onClick = useCallback(() => {
    dispatch(printCustomsForms(fulfillmentPlanIds));
    onClickProp();
  }, [dispatch, fulfillmentPlanIds, onClickProp]);

  const onDownload = useCallback(() => {
    dispatch(downloadDocument(DocumentType.CustomsForm, fulfillmentIds));
  }, [dispatch, fulfillmentIds]);

  const onPrint = useCallback(() => {
    dispatch(printDocument(DocumentType.CustomsForm, fulfillmentPlanIds, printSettings));
  }, [dispatch, fulfillmentPlanIds, printSettings]);

  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSettings, onPrint, onDownload),
    [printSettings, onDownload, onPrint],
  );

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={!canPrintCustoms}
      name={DocumentType.CustomsForm.documentNameTranslation}
      onClick={onClick}
    />
  );
};

CustomsForm.propTypes = {
  fulfillmentIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  fulfillmentPlanIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func,
};
